/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeJobsCreateJob } from "../../funcs/computeJobsCreateJob.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateJobRequest$inboundSchema,
};

export const tool$computeJobsCreateJob: ToolDefinition<typeof args> = {
  name: "compute-jobs-create-job",
  description: `Create a job`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeJobsCreateJob(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
